@let measureValue = measure();
@if (measureValue) {
  <div class="align-{{ align() }}">
    <div class="image" [style.background-image]="measureImageUrl()"></div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h3 class="card-title mb-4" [class]="cardTitleClass()">
              {{ measureValue.name ? measureValue.name : ('measure.name.' + measureValue.code | translate) }}
            </h3>
          </div>
          <div class="col-auto">
            <ng-content select="[title-content]" />
          </div>
        </div>
        @if (measureValue.buildingMeasureType === 'CALCULATED' || measureValue.description) {
          <p
            class="small"
            [class.pb-4]="showDetailsButton()"
            [class.mb-0]="!showDetailsButton()"
            [innerHtml]="
              measureValue.description ||
                (showSummary() ? 'measure.summary.' : 'measure.description.') + measureValue.code | translate
            "
          ></p>
        }
        @if (showDetailsButton()) {
          <div class="text-end">
            <a
              class="btn btn-primary"
              [routerLink]="`/energy/${portfolioId()}/buildings/${buildingId()}/measures/${measureValue.id}`"
              >{{ 'viewDetails' | translate }}</a
            >
          </div>
        }
        @if (showBusinesscase()) {
          <div class="row row-condensed mt-4">
            <div class="col-12 col-lg-4 col-print-4">
              <div class="alert alert-primary mb-lg-0 mb-print-0">
                <div class="row row-condensed">
                  <div class="col-auto">
                    <cfp-icon-square [icon]="environment.icons.iconSavings" />
                  </div>
                  <div class="col">
                    <label>{{ 'costReduction' | translate }}</label>
                    <h4>
                      {{ measureValue.costReduction | cfpCurrency: measureValue.currencyCode }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4 col-print-4">
              <div class="alert alert-primary mb-lg-0 mb-print-0">
                <div class="row row-condensed">
                  <div class="col-auto">
                    <cfp-icon-square [icon]="environment.icons.iconSubsidy" />
                  </div>
                  <div class="col">
                    <label>{{ 'investment' | translate }}</label>
                    <h4>
                      {{ measureValue.investment | cfpCurrency: measureValue.currencyCode }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4 col-print-4">
              <div class="alert alert-primary mb-lg-0 mb-print-0">
                <div class="row row-condensed">
                  <div class="col-auto">
                    <cfp-icon-square [icon]="environment.icons.iconCo2Reduction" />
                  </div>
                  <div class="col">
                    <label [innerHtml]="'businesscase.co2reduction' | translate"></label>
                    <h4 [innerHtml]="measureValue.co2ConsumptionReduction | co2: false"></h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
